import React, { useContext } from "react";

import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import {
	MarketsToggleButton,
	MyBetsToggleButton,
	StatisticsToggleButton,
} from "@features/offer/shared/event";
import { OfferStoreContext } from "@gp/components";
import { useRootAppStore } from "@hooks";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { observer } from "mobx-react-lite";

import { EventMarketsContent } from "./EventMarketsContent";
import { EventStatisticsContent } from "./EventStatisticsContent";
import { MyBetsContent } from "./my-bets/MyBetsContent";

export const EventContentTabs = observer(function EventContentTabs() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	const rootStore = useRootAppStore();

	return (
		<>
			{store.firstAvailableStats ? (
				<div className="event__tabs event__tabs--bordered u-padd--reset">
					<div className="tabs--primary">
						<MarketsToggleButton store={store} />
						<StatisticsToggleButton
							store={store}
							isDisabled={false}
						/>
						<MyBetsToggleButton store={store} />
					</div>
				</div>
			) : rootStore.userAuthStore.isLoggedIn ? (
				<div className="event__tabs event__tabs--bordered u-padd--reset">
					<div className="tabs--primary">
						<MarketsToggleButton store={store} />
						<MyBetsToggleButton store={store} />
					</div>
				</div>
			) : null}

			<EventMarketsContent />
			<ErrorBoundaryWithPropagation componentName="Desktop/EventContentTabs.tsx">
				<EventStatisticsContent />
			</ErrorBoundaryWithPropagation>

			<MyBetsContent />
		</>
	);
});
